const KEY_MIN = 0;
const KEY_MAX = 1;

/**
 *
 * @param {array} rangeA
 * @param {array} rangeB
 * @return {boolean}
 */
const isOverlapping = (rangeA, rangeB) => {
  if (rangeA[KEY_MIN] <= rangeB[KEY_MIN] && rangeB[KEY_MIN] <= rangeA[KEY_MAX]) {
    return true;
  }
  if (rangeA[KEY_MIN] <= rangeB[KEY_MAX] && rangeB[KEY_MAX] <= rangeA[KEY_MAX]) {
    return true;
  }
  // noinspection RedundantIfStatementJS - Disabled in favor of better readability
  if (rangeB[KEY_MIN] < rangeA[KEY_MIN] && rangeA[KEY_MAX] < rangeB[KEY_MAX]) {
    return true;
  }
  if (
    Math.abs(rangeA[KEY_MIN] - rangeB[KEY_MAX]) === 1 ||
    Math.abs(rangeA[KEY_MAX] - rangeB[KEY_MIN]) === 1
  ) {
    return true;
  }
  return false;
};

/**
 * Pass any number of ranges [min-width, max-width] and function will compile them to media-query.
 * It also optimizes ranges if they overlap.
 *
 * Pass 0 as min-width to not set min-width. Pass `Infinity` as max-width to not set max-width.
 *
 * @param {array} ranges
 * @param {string} only
 * @return {string}
 */
export const compileBreakpoints = (ranges, only = 'screen') => {
  let rangesArray = ranges;

  if (ranges.length === 2 && !Array.isArray(ranges[0])) { // Only one range was passed
    rangesArray = [ranges];
  }

  // Optimization
  for (let i = 0; i < rangesArray.length; i++) {
    for (let j = 0; j < rangesArray.length; j++) {
      if (i !== j && rangesArray[i] !== undefined && rangesArray[j] !== undefined) {
        const overlap = isOverlapping(rangesArray[i], rangesArray[j]);
        if (overlap) {
          rangesArray[i] = [
            Math.min(rangesArray[i][KEY_MIN], rangesArray[j][KEY_MIN]),
            Math.max(rangesArray[i][KEY_MAX], rangesArray[j][KEY_MAX])
          ];
          rangesArray[j] = undefined;
        }
      }
    }
  }

  return rangesArray
    .filter(item => !!item)
    .sort((rangeA, rangeB) => { // Sorting is just for better readability of result media queries
      if (rangeA[KEY_MIN] < rangeB[KEY_MIN]) {
        return -1;
      }
      if (rangeA[KEY_MIN] > rangeB[KEY_MIN]) {
        return 1;
      }
      return 0;
    })
    .map(([min, max]) => {
      let s = '';
      if (min > 0) {
        s += ` and (min-width: ${min}px)`;
      }
      if (max < Infinity) {
        s += ` and (max-width: ${max}px)`;
      }
      return `only ${only}${s}`;
    })
    .join(', ');
};
